import { apiService } from './api'
import { adminHttp, adminAuthConfig } from './adminHttp'

/** 요금제 관리 API */
export const adminPlanApi = {
  list: () =>
    adminHttp.get('/admin/plans', b => b.plans ?? [], '요금제 조회 실패'),

  /**
   * 요금제 통계.
   * 이 엔드포인트만 success 래퍼 없이 통계 객체를 그대로 돌려준다.
   */
  async stats(): Promise<Record<string, any>> {
    const { data } = await apiService.client.get(
      '/admin/plans/stats',
      adminAuthConfig()
    )
    if (data?.success === false) {
      throw new Error(data.message || '요금제 통계 조회 실패')
    }
    return data
  },

  create: (plan: unknown) =>
    adminHttp.post('/admin/plans', plan, b => b.plan, '요금제 생성 실패'),

  update: (id: string, plan: unknown) =>
    adminHttp.put(
      `/admin/plans/${encodeURIComponent(id)}`,
      plan,
      b => b.plan,
      '요금제 수정 실패'
    ),

  remove: (id: string) =>
    adminHttp.delete(
      `/admin/plans/${encodeURIComponent(id)}`,
      () => undefined,
      '요금제 삭제 실패'
    ),

  /** 플랜 변경 화면이 쓰는 목록 (요금제 관리와 별도 엔드포인트) */
  managementPlans: () =>
    adminHttp.get(
      '/admin/plan-management/plans',
      b => b.data?.plans ?? b.plans ?? [],
      '플랜 목록 조회 실패'
    ),

  changeUserPlan: (payload: unknown) =>
    adminHttp.post(
      '/admin/plan-management/change-plan',
      payload,
      b => b.data ?? b,
      '플랜 변경 실패'
    ),
}

export default adminPlanApi
